import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-checkbox-btn',
  templateUrl: './ui-checkbox-btn.component.html'
})
export class UiCheckboxBtnComponent {
  @Input() model: boolean;
  @Output() modelChange: EventEmitter<any> = new EventEmitter();

  onClick() {
    this.model = !this.model;
    this.modelChange.emit(this.model);
  }
}

